import { connect } from 'react-redux'
import { postMealVoucher } from '../../../../../../components/Basket/reducer'
import { findCinemaId } from '../../../../../../global/helpers'

const mapStateToProps = (state) => {
    const cinemaid = findCinemaId(state)
    return {
        cinemaid,
    }
}

const mapDispatchToProps = { postMealVoucher }

const hocSnackCard = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocSnackCard
